import { useMutation } from "@tanstack/react-query";
import {
  OrderPayableBy,
  OrderPayableTo,
} from "../enums";
import services from "../services";

export interface PatchEstimateSplitInput {
  estimateNo: string;
  splitId: string;
  payload: {
    transactionType?: string;
    discountPercentage?: number;
    creditNotePercentage?: number;
    payableBy?: OrderPayableBy;
    payableTo?: OrderPayableTo;
  };
}

export const usePatchEstimateSplit = () => {
  return useMutation({
    mutationKey: ["estimateSplit", "patch"],
    mutationFn: (data: PatchEstimateSplitInput) =>
      services.patchEstimateSplit(
        data.estimateNo,
        data.splitId,
        data.payload,
      ),
  });
};
